import * as React from 'react';
import Sharer from './Sharer';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

class DetailView extends React.Component {

    public state: any;
    public constructor(props: any) {

        super(props);
        const alias = (props.match) ? props.match.params.alias : 'no';
        // console.log('DetailView', props, alias);

        this.state = {
            alias: alias,
            title: 'title',
            job: {},
            loaded: false
        };

        var page = document.location.pathname;
        window.ga('set', 'page', page);
        window.ga('send', 'pageview');
    }

    public componentDidMount() {

        this.requestDetail(this.state.alias);
    }

    public requestDetail = async (alias: string) => {

        let that = this;
        const url = 'https://www.stellenanbieter.de/api/?single=' + alias;
        let json;

        // a
        // const storedData = sessionStorage.getItem(url);
        // if (storedData !== null) {
        //     json = JSON.parse(storedData);
        //     that.setState({
        //         job: json,
        //         loaded: true
        //     });

        //     console.log('state cache', that.state);
        //     return json;
        // }
        // z

        json = await fetch(url)
            .then(function (response: any) {

                return response.json();
            })
            .then(function (parsedData: any) {
                json = parsedData;
                // console.log('parsedData', parsedData);

                if (parsedData.length === 0) {
                    window.location.href = '/jobs/not-found';
                }

                that.setState({
                    job: parsedData[0],
                    loaded: true
                });

                sessionStorage.setItem(url, JSON.stringify(parsedData));

                window.ga('send', 'event', 'detailjob', 'show', that.state.alias, that.state.job.fe_user);

                // console.log(parsedData);
                // console.log('state live', that.state);
                return json;
            });
        return json;
    }

    public render() {
        
        let jobDate = '';
        let validThrough = '';
        if (this.state.job.date) {
            // console.log('detail', this.state.job);
            // const jobDateArray = this.state.job.date.split('-');
            // jobDate = jobDateArray[2] + '.' + jobDateArray[1] + '.' + jobDateArray[0];
            jobDate = this.state.job.date;
            var date = new Date(jobDate.replace( /(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
            date.setDate(date.getDate() + 60);
            let mm = date.getMonth() + 1; // getMonth() is zero-based
            let dd = date.getDate();
            validThrough = [date.getFullYear(),
                (mm > 9 ? '' : '0') + mm,
                (dd > 9 ? '' : '0') + dd
               ].join('-');
        }

        const jobUrl = 'https://www.stellenanbieter.de/jobs/stellenangebot/' + this.state.alias;
        
        return (
            <div>
                {this.state.loaded === false
                    ? <div className="loading">Das Stellenangebot wird geladen</div>
                    :
                    <div 
                        itemScope={true} 
                        itemType="http://schema.org/JobPosting" 
                        className={`detail-view-wrapper user-${this.state.job.fe_user}`}
                    >
                        <Helmet>
                            <title>Stellenangebot {this.state.job.title} - Stellenanbieter.de</title>
                            <link 
                                rel="canonical" 
                                href={jobUrl} 
                            />
                            <meta 
                                property="og:title" 
                                content={'Stellenangebot ' + this.state.job.title + ' - Stellenanbieter.de'} 
                            />
                            <meta 
                                property="og:description" 
                                content={'Stellenanbieter.de ' + this.state.job.description} 
                            />
                        </Helmet>

                        {this.state.job.fe_user === '26' && <div className="logo">
                            <img src="https://www.stellenanbieter.de/fileadmin/anbieter_logos/logo-rent-a-person.jpg" />
                        </div>}

                        <h1 itemProp="title">{this.state.job.title}</h1>
                        <Sharer 
                            title={'Jetzt schnell dieses Stellenangebot ansehen'} 
                            url={jobUrl} 
                        />

                        <div className="back-to-search">
                            <Link to={`/jobs`}>Zurück zur Suche</Link>
                        </div>

                        <div className="quick-info">
                        {this.state.job.date !== '' && 
                            <div>Einstellungsdatum: 
                                <span itemProp="datePosted">{jobDate}</span> (Gültig bis (
                                <span itemProp="validThrough">{validThrough}</span>)
                            </div>}
                            {this.state.job.city !== '' && <div>Arbeitsort: <span>{this.state.job.city}</span></div>}
                            {this.state.job.job.amount !== '' && 
                                <div>Anzahl zu besetzender Stellen: <span>{this.state.job.amount}</span></div>}
                        </div>
                        {this.state.job.fe_user !== '26' && this.getAd()}
                        {this.state.job.fe_user !== '26' && this.initAd()}

                        <div className="description">
                            <label>Beschreibung</label>
                            <p 
                                itemProp="description"
                                dangerouslySetInnerHTML={{__html: this.state.job.description}} 
                            />
                        </div>

                        {this.state.job.fe_user !== '26' && this.getAd()}
                        {this.state.job.fe_user !== '26' && this.initAd()}

                        {this.state.job.skills && 
                            <div>
                                <div className="profile">
                                    <label>Anforderungsprofil</label>
                                    <p 
                                        itemProp="skills" 
                                        dangerouslySetInnerHTML={{__html: this.state.job.skills}} 
                                    />
                                </div>
                                {/* {this.getAd()}
                                {this.initAd()} */}
                            </div>
                        }

                        {this.state.job.fe_user !== '26' && this.state.job.industries && 
                            this.state.job.industries !== 'Keine Branchenangabe machen' &&
                            <div>

                                <div className="profile">
                                    <label>Branche</label>
                                    <p itemProp="industry">{this.state.job.industries}</p>
                                </div>
                                {/* {this.getAd()}
                                {this.initAd()} */}
                            </div>
                        }

                        <div className="contact">
                            <label>Kontakt</label>
                            {this.state.job.fe_user === '26' && <div>{this.state.job.contact.lastname}</div>}
                            {this.state.job.fe_user !== '26' && this.state.job.contact.contacttitle !== '' &&
                                <div>{this.state.job.contact.contacttitle}</div>}
                            {this.state.job.contact.email !== '' && 
                            this.state.job.contact.email !== undefined &&
                                <div>E-Mail: <a href={'mailto:' + this.state.job.contact.email}>E-Mail</a></div>}
                            {this.state.job.contact.telephonenumber !== '' &&
                                <div>
                                    Telefon:&nbsp;
                                    {this.state.job.contact.telephonepre} {this.state.job.contact.telephonenumber}
                                </div>}
                            {this.state.job.contact.internet !== undefined &&
                                this.state.job.contact.internet !== '' && 
                                <div>
                                    {this.state.job.fe_user === '26' 
                                        ? <span>Jetzt bewerben: </span>
                                        : <span>Homepage: </span>
                                    }
                                    <a href={this.state.job.contact.internet} target="_blank">
                                        Seite aufrufen</a>
                                </div>}
                            
                            <div>
                                {this.state.job.contact.street !== '' &&
                                    <div>{this.state.job.contact.street}</div>}
                                {this.state.job.contact.city !== '' &&
                                    <div>{this.state.job.contact.zip} {this.state.job.contact.city}</div>}
                                <div>{this.state.job.contact.country}</div>
                            </div>
                        </div>

                        {this.state.job.fe_user !== '26' && this.getAd()}
                        {this.state.job.fe_user !== '26' && this.initAd()}

                        <div className="workplace">
                            <label>Arbeitsort</label>
                            {this.state.job.contact.company !== undefined &&
                                this.state.job.contact.company !== '' && <p>
                                    Firma: <span itemProp="hiringOrganization">{this.state.job.contact.company}</span>
                                </p>}
                            <p>
                            <span itemProp="jobLocation" itemScope={true} itemType="http://schema.org/Place">
                                <span itemProp="address" itemScope={true} itemType="http://schema.org/PostalAddress">
                                    Ort: <span itemProp="addressRegion">{this.state.job.country}</span>&nbsp;
                                    <span itemProp="postalCode">{this.state.job.zip}</span>&nbsp;
                                    <span itemProp="addressLocality">{this.state.job.city}</span>
                                </span>
                            </span>
                            </p>
                        </div>

                        {/* {this.getAd()}
                        {this.initAd()} */}

                        <div className="back-to-search">
                            <Link to={`/jobs`}>Zurück zur Suche</Link>
                        </div>

                    </div>
                }
            </div>
        );
    }

    private getAd() {

        return (
            <div className="full-block">
                <ins
                    className="adsbygoogle"
                    style={{ display: 'block' }}
                    data-ad-client="ca-pub-9629683982356381"
                    data-ad-slot="4763578003"
                    data-ad-format="auto"
                    data-full-width-responsive="true"
                />
            </div>
        );
    }

    private initAd() {

        setTimeout(
            () => {
                window.adsbygoogle.push({});
            },
            500);
        return (<span />);
    }

}

export default DetailView;



// WEBPACK FOOTER //
// ./src/DetailView.tsx